import React from 'react';
import { motion } from 'framer-motion';
import { Check, ShieldCheck, Zap, Smartphone, Search } from 'lucide-react';
import { Button } from './Button';
export function PricingSection() {
  return <section id="precios" className="py-24 bg-[#0a1120] relative" data-id="element-205">
      <div className="container mx-auto px-4 md:px-6" data-id="element-206">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-207">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-6" data-id="element-208">
            Transparencia Total en Precios
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-xl text-gray-400" data-id="element-209">
            Sin costos ocultos. Sin sorpresas.
          </motion.p>
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="max-w-lg mx-auto bg-nova-navy-dark rounded-3xl border-2 border-nova-gold shadow-[0_0_40px_rgba(184,150,78,0.15)] overflow-hidden relative" data-id="element-210">
          {/* Popular Badge */}
          <div className="absolute top-0 inset-x-0 bg-nova-gold text-nova-navy-dark text-center py-1.5 text-sm font-bold uppercase tracking-wider" data-id="element-211">
            Plan Más Elegido
          </div>

          <div className="p-8 pt-12" data-id="element-212">
            <h3 className="text-2xl font-bold text-white mb-2" data-id="element-213">
              Lanzamiento Digital
            </h3>
            <div className="flex items-baseline gap-2 mb-6" data-id="element-214">
              <span className="text-5xl font-extrabold text-white" data-id="element-215">$2,900</span>
              <span className="text-xl text-gray-400 font-medium" data-id="element-216">MXN</span>
            </div>
            <p className="text-nova-gold text-sm font-semibold mb-8 uppercase tracking-wider" data-id="element-217">
              Pago Único
            </p>

            <div className="space-y-4 mb-8" data-id="element-218">
              <div className="flex items-start gap-3" data-id="element-219">
                <Smartphone className="text-nova-gold shrink-0 mt-0.5" size={20} data-id="element-220" />
                <span className="text-gray-300" data-id="element-221">
                  Diseño Mobile-First de Alta Conversión
                </span>
              </div>
              <div className="flex items-start gap-3" data-id="element-222">
                <Zap className="text-nova-gold shrink-0 mt-0.5" size={20} data-id="element-223" />
                <span className="text-gray-300" data-id="element-224">
                  Estructura de Ventas (Copywriting)
                </span>
              </div>
              <div className="flex items-start gap-3" data-id="element-225">
                <Search className="text-nova-gold shrink-0 mt-0.5" size={20} data-id="element-226" />
                <span className="text-gray-300" data-id="element-227">
                  SEO Básico para Google Local
                </span>
              </div>
              <div className="flex items-start gap-3" data-id="element-228">
                <Check className="text-nova-gold shrink-0 mt-0.5" size={20} data-id="element-229" />
                <span className="text-gray-300" data-id="element-230">
                  Botones de Contacto Inmediato (WhatsApp/Llamada)
                </span>
              </div>
            </div>

            <div className="bg-nova-navy-light/20 rounded-xl p-5 border border-nova-navy-light/30 mb-8" data-id="element-231">
              <div className="flex items-center gap-2 mb-3" data-id="element-232">
                <ShieldCheck className="text-nova-gold" size={20} data-id="element-233" />
                <h4 className="font-bold text-white" data-id="element-234">Soporte y Blindaje</h4>
              </div>
              <div className="flex items-baseline gap-1 mb-3" data-id="element-235">
                <span className="text-2xl font-bold text-white" data-id="element-236">$360</span>
                <span className="text-sm text-gray-400" data-id="element-237">MXN / mes</span>
              </div>
              <p className="text-sm text-gray-400 leading-relaxed" data-id="element-238">
                Incluye: Hosting de alta velocidad, Certificado de Seguridad
                (SSL), actualizaciones mensuales y soporte humano por WhatsApp.
              </p>
            </div>

            <Button href="#contacto" className="w-full text-lg py-4" data-id="element-239">
              Comenzar mi Proyecto
            </Button>
          </div>
        </motion.div>
      </div>
    </section>;
}